/* eslint-disable */
import React, { Component, useState } from 'react';
import { Card, CardBody, Col, Row, Button, Container, Collapse, Table } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';
import { OrganizationChart } from 'primereact/organizationchart';
import './OrganizationChartCustomStyle.css';
import 'primereact/components/organizationchart/OrganizationChart.css';
import 'primereact/components/common/Common.css';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primeicons/primeicons.css';
import { groupBy } from '../../../factories/utils';

class SchemaChart extends Component {

    constructor() {
        super();
        let icon_1 = "M23.594 5.767c0-.004-.001-.007-.002-.011-.001-.01-.003-.02-.005-.03-.001-.004-.002-.008-.003-.012-.003-.01-.005-.019-.009-.028-.001-.004-.003-.008-.004-.011-.004-.009-.008-.018-.012-.027-.002-.003-.003-.007-.005-.01-.005-.01-.011-.019-.016-.028-.001-.002-.003-.005-.004-.007-.007-.011-.016-.022-.024-.032-.002-.002-.004-.004-.006-.007-.007-.008-.014-.015-.021-.023-.003-.003-.007-.006-.011-.01-.007-.006-.014-.012-.021-.017-.002-.002-.004-.003-.006-.005L16.469.331c-.065-.048-.143-.074-.224-.074H7.449c-.019 0-.036.002-.053.004-.004.001-.008.001-.011.002-.017.003-.035.007-.051.012-.002 0-.003.001-.004.002-.017.006-.033.012-.048.02-.002.001-.004.002-.006.003-.016.008-.032.018-.046.029-.001.001-.003.002-.004.002L.248 5.508C.153 5.578.097 5.69.097 5.809v12.853c0 .207.168 .375.375 .375h22.75c.207 0 .375-.168.375-.375V5.809C23.597 5.795 23.596 5.781 23.594 5.767zM5.245 18.287v-3.534h4.407v3.534H5.245zM.847 18.287V6.184h3.648v3.534h-.125c-.207 0-.375.168-.375.375s.168.375 .375.375h.125v3.534h-.125c-.207 0-.375.168-.375.375s.168.375 .375.375h.125v3.534H.847zM7.449 1.099l5.842 4.335H1.607L7.449 1.099zM9.652 14.003h-4.407v-3.534h4.407V14.003zM9.652 9.718h-4.407v-3.534h4.407V9.718zM10.402 6.184h3.648v12.103h-3.648V6.184zM19.199 18.287v-1.125c0-.207-.168-.375-.375-.375s-.375.168-.375.375v1.125h-3.648V5.809c0-.119-.056-.23-.151-.301L8.583 1.007h3.14l5.966 4.427h-1.764c-.207 0-.375.168-.375.375s.168.375 .375.375h2.523v9.478c0 .207.168 .375.375 .375s.375-.168.375-.375V5.809c0-.014-.001-.028-.002-.042 0-.004-.001-.007-.002-.011-.001-.01-.003-.02-.005-.03-.001-.004-.002-.008-.003-.012-.002-.01-.005-.019-.009-.028-.001-.004-.003-.008-.004-.011-.004-.009-.008-.019-.012-.028-.002-.003-.003-.007-.005-.01-.005-.01-.011-.019-.017-.029-.001-.002-.003-.004-.004-.007-.008-.011-.016-.022-.024-.033-.002-.002-.004-.004-.005-.006-.007-.008-.014-.016-.022-.024-.003-.003-.007-.006-.01-.009-.007-.006-.014-.012-.022-.018-.002-.001-.003-.003-.005-.005l-6.066-4.501h3.14l5.966 4.427h-1.764c-.207 0-.375.168-.375.375s.168.375 .375.375H22.847v12.103H19.199z";
        let icon_2 = "M11.234.797C5.583.797 .984 5.395.984 11.047s4.598 10.25 10.25 10.25 10.25-4.598 10.25-10.25S16.886.797 11.234.797zM19.915 14.904h-1.252v-2.071h1.902C20.427 13.555 20.207 14.249 19.915 14.904zM13.02 20.378v-1.902h2.071v1.252C14.437 20.02 13.743 20.24 13.02 20.378zM1.903 12.833h1.902v2.071H2.553C2.261 14.249 2.041 13.555 1.903 12.833zM1.734 11.047c0-.35.02-.695.057-1.036h2.015v2.071H1.791C1.754 11.742 1.734 11.397 1.734 11.047zM2.553 7.19h1.252v2.071H1.903C2.041 8.539 2.261 7.845 2.553 7.19zM9.449 1.716v1.902h-2.071V2.366C8.032 2.074 8.726 1.854 9.449 1.716zM20.565 9.261h-1.902v-2.071h1.252C20.207 7.845 20.427 8.539 20.565 9.261zM15.842 14.904v-2.071h2.071v2.071H15.842zM17.913 15.654v2.071h-2.071v-2.071H17.913zM12.645 14.404c-.207 0-.375.168-.375.375v.125h-2.071v-2.071h2.071v.446c0 .207.168 .375.375 .375s.375-.168.375-.375v-.446h2.071v2.071h-2.071v-.125C13.02 14.572 12.852 14.404 12.645 14.404zM4.556 14.904v-2.071h2.071v2.071H4.556zM6.627 15.654v2.071h-2.071v-2.071H6.627zM12.27 9.261h-2.071v-2.071h2.071V9.261zM13.02 7.19h2.071v2.071h-2.071V7.19zM10.199 10.011h2.071v2.071h-2.071V10.011zM9.449 12.083h-2.071v-2.071h2.071V12.083zM9.449 9.261h-2.071v-2.071h2.071V9.261zM6.627 9.261h-2.071v-2.071h2.071V9.261zM6.627 10.011v2.071h-2.071v-2.071H6.627zM7.377 12.833h2.071v2.071h-2.071V12.833zM15.842 12.083v-.446c0-.207-.168-.375-.375-.375s-.375.168-.375.375v.446h-2.071v-2.071h2.071v.125c0 .207.168 .375.375 .375s.375-.168.375-.375v-.125h2.071v2.071H15.842zM15.842 9.261v-2.071h2.071v2.071H15.842zM15.842 6.44v-2.071h2.071v2.071H15.842zM18.663 6.44v-1.307c.327.41 .62.847 .877 1.307H18.663zM15.842 3.618V2.741c.461.256 .898.55 1.307.877H15.842zM15.092 3.618h-2.071V1.716c.723.138 1.416.358 2.071.65V3.618zM15.092 4.368v2.071h-2.071v-2.071H15.092zM12.27 6.44h-2.071v-2.071h2.071V6.44zM9.449 6.44h-2.071v-.47c0-.207-.168-.375-.375-.375s-.375.168-.375.375v.47h-2.071v-2.071h2.071v.101c0 .207.168 .375.375 .375s.375-.168.375-.375v-.101h2.071V6.44zM6.627 3.618h-1.307c.41-.327.847-.62 1.307-.877V3.618zM3.806 6.44H2.929c.256-.461.55-.898.877-1.307V6.44zM3.806 15.654v1.307c-.327-.41-.62-.847-.877-1.307H3.806zM6.627 18.475v.877c-.461-.256-.898-.55-1.307-.877H6.627zM7.377 18.475h2.071v1.902c-.723-.138-1.417-.358-2.071-.65V18.475zM7.377 17.725v-2.071h2.071v2.071H7.377zM10.199 15.654h2.071v2.071h-2.071V15.654zM13.02 15.654h2.071v2.071h-2.071V15.654zM15.842 18.475h1.307c-.41.327-.847.62-1.307.877V18.475zM18.663 15.654h.877c-.256.461-.55.898-.877 1.307V15.654zM18.663 12.083v-2.071h2.015C20.715 10.351 20.734 10.697 20.734 11.047s-.02.695-.057 1.036H18.663zM12.27 3.618h-2.071V1.604C10.539 1.566 10.884 1.547 11.234 1.547s.695.02 1.036.057V3.618zM10.199 18.475h2.071v2.015C11.93 20.527 11.584 20.547 11.234 20.547s-.695-.02-1.036-.057V18.475z";
        this.state = {
            assetid: 220,
            data1: [{
                label: 'PLANT',
                type: 'person',
                className: 'p-person',
                expanded: true,
                data: { name: 'Walter White', avatar: 'walter.jpg', assetid: 0, assetname: "Plant_01", icon: icon_1 },
                icon: icon_1,
                children: [
                    {
                        label: 'CONTROL ROOM 1',
                        type: 'person',
                        className: 'p-person',
                        expanded: true,
                        data: { name: 'Saul Goodman', avatar: 'saul.jpg', assetid: 0, assetname: "test_01", icon: icon_2 },
                        icon: icon_2,
                        // children:[{
                        //     label: 'Tax',
                        //     className: 'department-cfo'
                        // },
                        // {
                        //     label: 'Legal',
                        //     className: 'department-cfo'
                        // }],
                    },
                    {
                        label: 'CONTROL ROOM 2',
                        type: 'person',
                        className: 'p-person',
                        expanded: true,
                        data: { name: 'Mike E.', avatar: 'mike.jpg', assetid: 0, assetname: "test_02", icon: icon_2 },
                        icon: icon_2,
                        // children:[{
                        //     label: 'Operations',
                        //     className: 'department-coo'
                        // }]
                    },
                    {
                        label: 'CONTROL ROOM 3',
                        type: 'person',
                        className: 'p-person',
                        expanded: true,
                        data: { name: 'Jesse Pinkman', 'avatar': 'jesse.jpg', assetid: 220, assetname: "sensor_01", icon: icon_2 },
                        icon: icon_2,
                        // children:[{
                        //     label: 'Development',
                        //     className: 'department-cto',
                        //     expanded: true,
                        //     children:[{
                        //         label: 'Analysis',
                        //         className: 'department-cto'
                        //     },
                        //     {
                        //         label: 'Front End',
                        //         className: 'department-cto'
                        //     },
                        //     {
                        //         label: 'Back End',
                        //         className: 'department-cto'
                        //     }]
                        // },
                        // {
                        //     label: 'QA',
                        //     className: 'department-cto'
                        // },
                        // {
                        //     label: 'R&D',
                        //     className: 'department-cto'
                        // }]
                    }
                ]
            }],
            // data2 : [{
            //     label: 'F.C Barcelona',
            //     expanded: true,
            //     children: [
            //         {
            //             label: 'F.C Barcelona',
            //             expanded: true,
            //             children: [
            //                 {
            //                     label: 'Chelsea FC'
            //                 },
            //                 {
            //                     label: 'F.C. Barcelona'
            //                 }
            //             ]
            //         },
            //         {
            //             label: 'Real Madrid',
            //             expanded: true,
            //             children: [
            //                 {
            //                     label: 'Bayern Munich'
            //                 },
            //                 {
            //                     label: 'Real Madrid'
            //                 }
            //             ]
            //         }
            //     ]
            // }],
            selection: []
        };

        this.nodeTemplate = this.nodeTemplate.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.assetData && nextProps.assetData != this.props.assetData) {
            if (nextProps.assetData.length > 0 && nextProps.assetData[0].asset && nextProps.assetData[0].asset.length > 0) {
                for (let i = 0; i < nextProps.assetData[0].asset.length; i++) {
                    let assetObj = nextProps.assetData[0].asset[i];
                    if (assetObj.assetid == this.state.assetid) {
                        this.setState({
                            asset: assetObj,
                        });
                        break;
                    }
                }
            }
        }
        if (nextProps.updatedData && nextProps.updatedData !== this.props.updatedData) {
            // 
            this.updateAssetValue(nextProps.updatedData)
        }
    }

    updateAssetValue(pubData) {
        // 
        // let dataObj = JSON.parse(JSON.stringify(pubData));
        let dataObj = JSON.parse(pubData);
        //  
        //  
        if (dataObj) {
            this.setState(prevState => {
                if (prevState.asset && prevState.asset.device) {
                    for (let i = 0; i < prevState.asset.device.length; i++) {
                        let deviceObj = prevState.asset.device[i];
                        if (dataObj.deviceid == deviceObj.deviceid) {
                            if (deviceObj.msgs && dataObj.msgs && dataObj.msgs.length > 0) {
                                let msgArr = deviceObj.msgs;
                                let newMsgObj = dataObj.msgs[dataObj.msgs.length - 1];
                                let foundIndex = msgArr.findIndex((msg, mindex) => (msg.msgid == newMsgObj.msgId));
                                if (foundIndex < 0) {
                                    msgArr.unshift(newMsgObj);
                                    return ({
                                        asset: prevState.asset,
                                    });
                                }
                            }
                            break;
                        }
                    }

                }
            });

            // if (dataObj.msgs && dataObj.msgs.length > 0) {
            //     let msgObj = dataObj.msgs[dataObj.msgs.length-1];
            //      
            //     Object.entries(msgObj.msg).forEach(([attr, attrObj],mindex)=>{
            //          
            //          
            //         // if (attrObj.id == this.props.parameter.attrid){
            //         if (attrObj.attributename == this.props.parameter.attrname){
            //             // this.setState({
            //             //     dataValue: attrObj.value,
            //             // });
            //             this.setValue(attrObj.value, this.state.threshold);
            //         }
            //     });
            // }
        }

    }

    nodeTemplate = (node) => {
        if (node.type === "person") {
            let data = [];
            let lable = ['Temperature', 'Humidity'];
            if (this.state.asset && this.state.asset.device) {
                let deviceArr = this.state.asset.device;
                for (let i = 0; i < deviceArr.length; i++) {
                    if (deviceArr[i].msgs && deviceArr[i].msgs.length > 0) {
                        let msgObj = deviceArr[i].msgs[0];
                        Object.entries(msgObj.msg).forEach(([key, value], index) => {
                            if (lable.includes(key)) {
                                data.push(value);
                                lable = lable.filter((item, id) => (item != key));
                            }
                        })
                    }
                }
            }
            return (
                <div>
                    <div className="node-header">
                        {/* {this.svgFormatter(node.data.icon, 30, 30, '#ffffff')}{' '} */}
                        {this.svgFormatter(node.icon, 30, 30, '#ffffff')}{' '}
                        {node.label}
                    </div>
                    <div className="node-content">
                        {/* <img alt={node.data.avatar} src={'showcase/resources/demo/images/organization/${node.data.avatar}'} style={{ width: '32px' }}/> */}
                        <div><h4><b>{node.data.assetname}</b></h4></div>
                        {node.data.assetid == this.state.assetid && data && data.map((d, di) => (
                            <div key={di}>
                                {d.displayname} : {d.value}
                            </div>

                        ))}
                    </div>
                </div>
            );
        }

        if (node.type === "department") {
            return node.label;
        }
    }

    nodeTemplate2 = (node) => {
        if (node.type === "assetnode") {
            // let data = [];
            // let lable = ['Temperature', 'Humidity'];
            // if (this.state.asset && this.state.asset.device){
            //     let deviceArr = this.state.asset.device; 
            //     for (let i = 0 ; i < deviceArr.length; i++) {
            //         if (deviceArr[i].msgs && deviceArr[i].msgs.length >0 ){
            //             let msgObj = deviceArr[i].msgs[0];
            //             Object.entries(msgObj.msg).forEach(([key, value], index)=>{
            //                 if (lable.includes(key)){
            //                     data.push(value);
            //                     lable = lable.filter((item, id) => (item != key));
            //                 }
            //             })
            //         }
            //     }
            // }
            let data = null;
            if (node.data) {
                data = groupBy(node.data, item => item.devicename);

            }

            return (
                <div>
                    <div className="node-header">
                        {/* {this.svgFormatter(node.data.icon, 30, 30, '#ffffff')}{' '} */}
                        {this.svgFormatter(node.icon, 30, 30, '#ffffff')}{' '}
                        {node.label}
                    </div>
                    <div className="node-content">
                        {/* <img alt={node.data.avatar} src={'showcase/resources/demo/images/organization/${node.data.avatar}'} style={{ width: '32px' }}/> */}
                        {data && Array.from(data).map(([key, value]) => (
                            <div>
                                <h4><b>{key}</b></h4>
                                {value && value.map((d, di) => (
                                    <div key={di}>
                                        {d.attributename} : {d.value}
                                    </div>

                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    nodeTemplate3 = (node) => {
        if (node.type === "assetnode") {
            return (
                <TemplateDataList node={node}></TemplateDataList>
            );
        }
        else {
            return null;
        }
    }

    svgFormatter = (data, width, height, color) => {
        return (
            //   <svg width="50px" height="50px" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
            //     <path fill="none" stroke="#444"
            //       d={data} />
            //   </svg>
            <svg width={width} height={height} viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill="none"
                    stroke={color}
                    d={data}
                />
            </svg>
        )
    }


    handleSelectionChange = (event) => {
        this.setState({ selection: event.data })
        this.props.handleSelectionChange(event);
    }

    render() {

        return (
            <div>
                {/* <div className="content-section introduction">
                    <div className="feature-intro">
                        <h1>OrganizationChart</h1>
                        <p>OrganizationChart visualized hierarchical organization data.</p>
                    </div>
                </div> */}

                {/* <div className="content-section implementation organizationchart-demo"> */}

                <Card>
                    <div className='card-pginside'>
                        <h3>Schema</h3>
                        {this.props.treeData && this.props.treeData.length > 0 &&
                            <OrganizationChart
                                // value={this.state.data1} 
                                // nodeTemplate={this.nodeTemplate} 
                                value={this.props.treeData}
                                nodeTemplate={this.nodeTemplate3}
                                selection={this.state.selection}
                                selectionMode="single"
                                onSelectionChange={this.handleSelectionChange} className="company schema-chart"></OrganizationChart>
                        }
                        {this.props.loading &&
                            <div style={{ position: 'Absolute ', height: '100%', width: '100%', top: '0px', left: '0px', display: 'flex', textAlign: 'center', alignItems: 'center', backgroundColor: '#000', opacity: 0.3 }}>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    variant="primary"
                                    // size="sm"
                                    // role="status"
                                    // aria-hidden="true"
                                    style={{ display: 'inline-block', margin: 'auto' }}
                                />
                            </div>
                        }
                    </div>
                </Card>

                {/* <h3>Basic</h3>
                    <OrganizationChart value={this.state.data2}></OrganizationChart> */}
                {/* </div> */}
            </div>
        )
    }
}

export default SchemaChart;

const TemplateDataList = (props) => {
    const [showAll, setShowAll] = useState(false);
    const handleLinkClick = (e) => {
        e.stopPropagation();
        setShowAll(!showAll);
    }
    const { node } = props;
    const Link = <a onClick={(e) => handleLinkClick(e)}>{showAll ? <span>show less ...</span> : <span>show more ...</span>}</a>;
    let data = null;
    if (node.data) {
        if (showAll) {
            data = groupBy(node.data, item => item.devicenamealias ? item.devicenamealias : item.devicename);
            // data =  groupBy(node.data, item=>item.devicename);
        } else {
            data = groupBy(node.data.slice(0, 3), item => item.devicenamealias ? item.devicenamealias : item.devicename);
            // data =  groupBy(node.data.slice(0,3), item=>item.devicename);
        }
        // data =  groupBy(node.data, item=>item.devicename);

    }
    return (
        <div >
            <div className="node-header">
                {/* {this.svgFormatter(node.data.icon, 30, 30, '#ffffff')}{' '} */}
                {svgFormatter(node.icon, 30, 30, '#ffffff')}{' '}
                {node.label}
            </div>
            <div className="node-content">
                {/* <img alt={node.data.avatar} src={'showcase/resources/demo/images/organization/${node.data.avatar}'} style={{ width: '32px' }}/> */}
                {data && data.size > 0 && Array.from(data).map(([key, value]) => (
                    <div>
                        <h5><b>{key}</b></h5>
                        <table style={{ width: '100%' }}>
                            {value && value.map((d, di) => (
                                <tr key={di}>
                                    <td style={{ padding: '0', textAlign: 'left', fontSize: '12px' }}>
                                        {d.attributename}
                                    </td>
                                    <td style={{ padding: '0', textAlign: 'right', fontSize: '12px' }}>
                                        {d.value}
                                    </td>
                                </tr>

                            ))}
                        </table>
                        <br />
                    </div>
                ))}

                {data && data.size > 0 && Link}
                {(!data || data.size === 0) &&
                    <span>No data display...</span>
                }
            </div>
        </div>
    );
}

const svgFormatter = (data, width, height, color) => {
    return (
        <svg width={width} height={height} viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
            <path
                fill="none"
                stroke={color}
                d={data}
            />
        </svg>
    )
}
